module.exports = __webpack_public_path__ + "static/media/i-ambientworks.3644bf7.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/ambient-works/i-ambientworks.mp3
// module id = la+K
// module chunks = 0